// module_configs/solar.js
import React from 'react';
import {
  faGaugeHigh, faUserPlus, faUsersLine, faUserTie, faBuildingUser, faIdCard,
  faCube, faListAlt, faBuildingColumns, faCartPlus, faFileInvoice, faReceipt,
  faListCheck, faQrcode, faPrint, faClipboardList, faPlus, faBullhorn,
  faLayerGroup, faBoxes, faCog, faSun, faHandshake, faCashRegister, faWallet,
  faExchangeAlt, faUserFriends, faUserCog, faStoreAlt, faShoppingCart,
  faUndoAlt, faFileInvoiceDollar, faBoxOpen, faDolly, faCertificate,
  faArrowRotateLeft as faReturnArrow,
  faFileExport,
  faFileImport,
  faUsersCog as faUserManagement,
  faDoorOpen,
  faUserShield,
  faCoins,
  faFileInvoice as faBillingInvoice,
  faSync,
  faHistory,
  faSlidersH
} from '@fortawesome/free-solid-svg-icons';

// Import Solar components
import DashboardHome from '.././module_cosmetics/cosmetics_homedash';

import SolarProducts from '.././module_solar/solar_products';

import SolarProductsList from '.././module_solar/solar_productslist';

import SolarPurchases from '.././module_solar/solar_Purchases';

import SolarPurchaseList from '.././module_solar/solar_PurchaseList';

import SolarReturn from '.././module_solar/solar_Return';

import SolarReturnList from '.././module_solar/solar_returnlist';

import SolarSell from '.././module_solar/solar_Sell';

import SolarSalesList from '.././module_solar/solar_SellList';

import PendingInvoices from '.././module_solar/solar_pendinginvioces';

import PendingInvoicesList from '.././module_solar/solar_pendinginvoiceslist';

import SolarPartners from '.././module_solar/solar_partners';

import SolarPartnersList from '.././module_solar/solar_partnerslist';

import SolarGatepass from '.././module_solar/solar_gatepass';

import SolarGatepassList from '.././module_solar/solar_gatepasslist';

import SolarWarranty from '.././module_solar/solar_warranty';

import SolarWarrantyList from '.././module_solar/solar_warrantylist';

import MechanicsBarcode from '.././module_mechanics/mechanics_BarcodeGenerator';

import MechanicsAddCustomer from '.././module_mechanics/mechanics_customer';

import MechanicsCustomerList from '.././module_mechanics/mechanics_customer_list';

import MechanicsAddSupplier from '.././module_mechanics/mechanics_Supplier';

import MechanicsSuppliersList from '.././module_mechanics/mechanics_SuppliersList';

import MechanicsAddEmployee from '.././module_mechanics/mechanics_employees';

import MechanicsEmployeesList from '.././module_mechanics/mechanic_employeelist';

import RootUsers from '.././module_roots/RootUsers';

import MessageSystem from '.././module_roots/MessageSystem';

import AddTransactionForm from '.././module_cosmetics/cosmetics_addtransactions';

import CosmeticsTransactions from '../module_cosmetics/cosmetics_transactions';

import CosmeticsSupplierPurchases from '.././module_cosmetics/cosmetics_PurchasesSupplierwise';

import CosmeticsInvoicePurchaseList from '.././module_cosmetics/cosmetics_InvoicePurchaseList';
import StockTransfer from '../module_solar/solar_stocktransfer';
import CentralizedAssignment from '../module_solar_v0/solar_productcentralization';
import MechanicsAccounts from '../module_cosmetics/cosmetics_Accounts';
import MechanicsCashLedger from '../module_cosmetics/cosmetics_CashLedger';
import CosmeticsPurchaseReturn from '../module_cosmetics/cosmetics_purchasereturn';
import CosmeticsPurchaseReturnList from '../module_cosmetics/cosmetics_PurchaseReturnlist';
import SolarSpecialProducts from '../module_solar/solar_specialproducts';
import SolarSpecialProductsList from '../module_solar/solar_specialproductslist';
import SolarSpecialSell from '../module_solar/solar_SpecialSell';
import SolarSpecialSalesList from '../module_solar/solar_specialSellList';

export const solarConfig = {
  moduleId: 'solar',
  moduleName: 'Solar',
  icon: faSun,
  description: 'Solar Energy Management System',
  i18n: {
    defaultLanguage: 'en',
    supportedLanguages: ['en', 'ur', 'ps', 'ar', 'tr', 'fa', 'prs'],
    rtlLanguages: ['ur', 'ps', 'ar', 'fa', 'prs']
  },

  dashboardComponent: DashboardHome,

  roles: {
    'admin_solar': { level: 1, label: 'Admin', color: '#f59e0b' },
    'manager_solar': { level: 2, label: 'Manager', color: '#d97706' },
    'user_solar': { level: 3, label: 'User', color: '#b45309' },
    'viewer_solar': { level: 4, label: 'Viewer', color: '#92400e' }
  },

  menuGroups: [
    { id: 'management', name: 'Management', icon: faUserManagement, order: 1 },
    { id: 'sales', name: 'Sales & Sales Returns', icon: faCashRegister, order: 2 },
    { id: 'inventory', name: 'Stock & Inventory', icon: faBoxes, order: 3 },
    { id: 'accounts', name: 'Accounts & Transactions', icon: faCoins, order: 4 },
    { id: 'billing', name: 'Billing & Renewals', icon: faBillingInvoice, order: 5 },
    { id: 'settings', name: 'Settings', icon: faCog, order: 6 }
  ],

  menus: [
    // ==================== SECTION 1: MANAGEMENT ====================
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUserFriends,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: MechanicsAddCustomer,
          icon: faUserPlus,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: MechanicsCustomerList,
          icon: faUsersLine,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faStoreAlt,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: MechanicsAddSupplier,
          icon: faUserTie,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: MechanicsSuppliersList,
          icon: faBuildingUser,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'partners',
      label: 'Partners',
      icon: faHandshake,
      roles: ['admin_solar', 'manager_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addpartners',
          label: 'Add Partner',
          component: SolarPartners,
          icon: faUserPlus,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'partnerslist',
          label: 'Partners List',
          component: SolarPartnersList,
          icon: faUsersLine,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserCog,
      roles: ['admin_solar', 'manager_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'management',
      position: 4,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: MechanicsAddEmployee,
          icon: faUserPlus,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: MechanicsEmployeesList,
          icon: faIdCard,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'gatepass',
      label: 'Gatepass',
      icon: faDoorOpen,
      roles: ['admin_solar', 'manager_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'management',
      position: 5,
      submenus: [
        {
          id: 'addgatepass',
          label: 'Add Gatepass',
          component: SolarGatepass,
          icon: faPlus,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'gatepasslist',
          label: 'Gatepass List',
          component: SolarGatepassList,
          icon: faListAlt,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },

    // ==================== SECTION 2: SALES & SALES RETURNS ====================
    {
      id: 'sales',
      label: 'Sales',
      icon: faCashRegister,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'sales',
      position: 0,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: SolarSell,
          icon: faCartPlus,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: SolarSalesList,
          icon: faClipboardList,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'specialsales',
      label: 'General Sales',
      icon: faCashRegister,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'sales',
      position: 0,
      submenus: [
        {
          id: 'addsale',
          label: 'New',
          component: SolarSpecialSell,
          icon: faCartPlus,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'saleslist',
          label: 'Sales History',
          component: SolarSpecialSalesList,
          icon: faClipboardList,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'returns',
      label: 'Sales Returns',
      aliases: ['sale_return', 'sales_return', 'salereturn', 'salesreturns', 'solar_return'],
      icon: faFileExport,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'sales',
      position: 1,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Return',
          aliases: ['add_sale_return', 'new_sale_return', 'solar_return'],
          component: SolarReturn,
          icon: faReturnArrow,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'returnlist',
          label: 'Return List',
          aliases: ['sale_return_list', 'sales_return_list', 'solar_returnlist'],
          component: SolarReturnList,
          icon: faListCheck,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'pendinginvoices',
      label: 'Pending Invoices',
      icon: faFileInvoiceDollar,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'sales',
      position: 2,
      submenus: [
        {
          id: 'pendinginvoicesadd',
          label: 'Add Invoice',
          component: PendingInvoices,
          icon: faPlus,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'invoiceslist',
          label: 'Invoices List',
          component: PendingInvoicesList,
          icon: faListAlt,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },

    // ==================== SECTION 3: STOCK & INVENTORY ====================
    {
      id: 'stock',
      label: 'Stock Management',
      icon: faBoxOpen,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      denied_shopid: [53],
      allowed_shopid: [],
      description: 'Manage Stock',
      groupId: 'inventory',
      position: 0,
      submenus: [
        {
          id: 'addstock',
          label: 'Add Stock',
          component: SolarProducts,
          icon: faCube,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [53],
          allowed_shopid: [],
        },
        {
          id: 'specialproduct',
          label: 'Add Product',
          component: SolarSpecialProducts,
          icon: faListAlt,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
        
          allowed_shopid: [],
        },
        {
          id: 'specialproductslist',
          label: 'Products List',
          component: SolarSpecialProductsList,
          icon: faListAlt,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
        
          allowed_shopid: [],
        },
        {
          id: 'stocklist',
          label: 'Stock List',
          component: SolarProductsList,
          icon: faListAlt,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
         
          allowed_shopid: [],
        },
        {
          id: 'stocktransfer',
          label: 'Stock Transfer',
          component: StockTransfer,
          icon: faDolly,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [53],
          allowed_shopid: [],
        },
        {
          id: 'stockcentralization',
          label: 'Stock Centralization',
          component: CentralizedAssignment,
          icon: faLayerGroup,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [53],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase Management',
      icon: faShoppingCart,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'inventory',
      position: 1,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: SolarPurchases,
          icon: faCartPlus,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: SolarPurchaseList,
          icon: faFileInvoice,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'purchasessupplierwise',
          label: 'Supplier-wise',
          component: CosmeticsSupplierPurchases,
          icon: faStoreAlt,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'purchasesinvoicewise',
          label: 'Bill-wise',
          component: CosmeticsInvoicePurchaseList,
          icon: faReceipt,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'purchasereturns',
      label: 'Purchase Returns',
      aliases: ['purchase_return', 'purchasereturn', 'purchase_returns'],
      icon: faFileImport,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'inventory',
      position: 2,
      submenus: [
        {
          id: 'addpurchasereturn',
          label: 'New Return',
          aliases: ['add_purchase_return', 'new_purchase_return', 'purchasereturn'],
          component: CosmeticsPurchaseReturn,
          icon: faUndoAlt,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'purchasereturnlist',
          label: 'Return List',
          aliases: ['purchase_return_list', 'purchasereturnlist'],
          component: CosmeticsPurchaseReturnList,
          icon: faListCheck,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'barcode',
      label: 'Barcodes',
      icon: faQrcode,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'inventory',
      position: 3,
      submenus: [
        {
          id: 'barcodeprinting',
          label: 'Barcode Printing',
          component: MechanicsBarcode,
          icon: faPrint,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },

    // ==================== SECTION 4: ACCOUNTS & TRANSACTIONS ====================
    {
      id: 'financials',
      label: 'Financial Management',
      icon: faCoins,
      roles: ['admin_solar', 'manager_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'accounts',
      position: 0,
      submenus: [
        {
          id: 'newtransaction',
          label: 'New Transaction',
          component: AddTransactionForm,
          icon: faPlus,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'alltransactions',
          label: 'All Transactions',
          component: CosmeticsTransactions,
          icon: faExchangeAlt,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'accounts',
          label: 'Accounts',
          component: MechanicsAccounts,
          icon: faBuildingColumns,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'cashledger',
          label: 'Cash & Bank Ledger',
          component: MechanicsCashLedger,
          icon: faWallet,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },

    // ==================== SECTION 5: BILLING & RENEWALS ====================
    {
      id: 'warranty',
      label: 'Warranty Management',
      icon: faCertificate,
      roles: ['admin_solar', 'manager_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'billing',
      position: 0,
      submenus: [
        {
          id: 'addwarranty',
          label: 'Add Warranty',
          component: SolarWarranty,
          icon: faPlus,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'warrantylist',
          label: 'Warranty List',
          component: SolarWarrantyList,
          icon: faListAlt,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },
    {
      id: 'billing',
      label: 'Billing & Renewals',
      icon: faBillingInvoice,
      roles: ['admin_solar', 'manager_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'billing',
      position: 1,
      submenus: [
        {
          id: 'generatebill',
          label: 'Generate Bill',
          component: null,
          icon: faPlus,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'billinghistory',
          label: 'Billing History',
          component: null,
          icon: faHistory,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'renewals',
          label: 'Renewals',
          component: null,
          icon: faSync,
          roles: ['admin_solar', 'manager_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    },

    // ==================== SECTION 6: SETTINGS ====================
    {
      id: 'settings',
      label: 'System Settings',
      icon: faSlidersH,
      component: RootUsers,
      roles: ['admin_solar'],
      denied_shopid: [],
      allowed_shopid: [],
      groupId: 'settings',
      position: 0,
      submenus: [
        {
          id: 'users',
          label: 'User Management',
          component: RootUsers,
          icon: faUserShield,
          roles: ['admin_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        },
        {
          id: 'systemupdates',
          label: 'Notifications Center',
          component: MessageSystem,
          icon: faBullhorn,
          roles: ['admin_solar', 'manager_solar', 'user_solar'],
          denied_shopid: [],
          allowed_shopid: [],
        }
      ]
    }
  ],

  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '4,200' },
    { id: 'products', label: 'Products', icon: 'faBoxes', value: 78 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 45 },
    { id: 'pending', label: 'Pending Invoices', icon: 'faClock', value: 9 }
  ],

  // Every menu and submenu has one unique executable shortcut.  `menuId` and
  // `submenuId` are consumed by DashboardBusinessManager; descriptions are
  // intentionally kept here so the on-screen help always matches the handler.
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard', menuId: 'dashboard' },

    { key: 'Alt + C', description: 'Customers', menuId: 'customers' },
    { key: 'Alt + Shift + A', description: 'Add Customer', menuId: 'customers', submenuId: 'addcustomer' },
    { key: 'Alt + Shift + B', description: 'Customer List', menuId: 'customers', submenuId: 'customerlist' },

    { key: 'Alt + S', description: 'Suppliers', menuId: 'suppliers' },
    { key: 'Alt + Shift + C', description: 'Add Supplier', menuId: 'suppliers', submenuId: 'addsupplier' },
    { key: 'Alt + Shift + D', description: 'Supplier List', menuId: 'suppliers', submenuId: 'supplierlist' },

    { key: 'Alt + P', description: 'Partners', menuId: 'partners' },
    { key: 'Alt + Shift + E', description: 'Add Partner', menuId: 'partners', submenuId: 'addpartners' },
    { key: 'Alt + Shift + F', description: 'Partners List', menuId: 'partners', submenuId: 'partnerslist' },

    { key: 'Alt + E', description: 'Employees', menuId: 'employees' },
    { key: 'Alt + Shift + G', description: 'Add Employee', menuId: 'employees', submenuId: 'addemployees' },
    { key: 'Alt + Shift + H', description: 'Employees List', menuId: 'employees', submenuId: 'employeeslist' },

    { key: 'Alt + G', description: 'Gatepass', menuId: 'gatepass' },
    { key: 'Alt + Shift + I', description: 'Add Gatepass', menuId: 'gatepass', submenuId: 'addgatepass' },
    { key: 'Alt + Shift + J', description: 'Gatepass List', menuId: 'gatepass', submenuId: 'gatepasslist' },

    { key: 'Alt + A', description: 'Sales', menuId: 'sales' },
    { key: 'Alt + Shift + K', description: 'New Sale', menuId: 'sales', submenuId: 'addsale' },
    { key: 'Alt + Shift + L', description: 'Sales List', menuId: 'sales', submenuId: 'saleslist' },

    { key: 'Alt + R', description: 'Sales Returns', menuId: 'returns' },
    { key: 'Alt + Shift + M', description: 'New Sales Return', menuId: 'returns', submenuId: 'addreturn' },
    { key: 'Alt + Shift + N', description: 'Sales Return List', menuId: 'returns', submenuId: 'returnlist' },

    { key: 'Alt + I', description: 'Pending Invoices', menuId: 'pendinginvoices' },
    { key: 'Alt + Shift + O', description: 'Add Pending Invoice', menuId: 'pendinginvoices', submenuId: 'pendinginvoicesadd' },
    { key: 'Alt + Shift + P', description: 'Pending Invoices List', menuId: 'pendinginvoices', submenuId: 'invoiceslist' },

    { key: 'Alt + K', description: 'Stock Management', menuId: 'stock' },
    { key: 'Alt + Shift + Q', description: 'Add Stock', menuId: 'stock', submenuId: 'addstock' },
    { key: 'Alt + Shift + R', description: 'Stock List', menuId: 'stock', submenuId: 'stocklist' },
    { key: 'Alt + Shift + S', description: 'Stock Transfer', menuId: 'stock', submenuId: 'stocktransfer' },
    { key: 'Alt + Shift + T', description: 'Stock Centralization', menuId: 'stock', submenuId: 'stockcentralization' },

    { key: 'Alt + U', description: 'Purchase Management', menuId: 'purchases' },
    { key: 'Alt + Shift + U', description: 'New Purchase', menuId: 'purchases', submenuId: 'addpurchase' },
    { key: 'Alt + Shift + V', description: 'Purchases List', menuId: 'purchases', submenuId: 'purchaselist' },
    { key: 'Alt + Shift + W', description: 'Supplier-wise Purchases', menuId: 'purchases', submenuId: 'purchasessupplierwise' },
    { key: 'Alt + Shift + X', description: 'Bill-wise Purchases', menuId: 'purchases', submenuId: 'purchasesinvoicewise' },

    { key: 'Alt + T', description: 'Purchase Returns', menuId: 'purchasereturns' },
    { key: 'Alt + Shift + Y', description: 'New Purchase Return', menuId: 'purchasereturns', submenuId: 'addpurchasereturn' },
    { key: 'Alt + Shift + Z', description: 'Purchase Return List', menuId: 'purchasereturns', submenuId: 'purchasereturnlist' },

    { key: 'Alt + B', description: 'Barcodes', menuId: 'barcode' },
    { key: 'Alt + Shift + 0', description: 'Barcode Printing', menuId: 'barcode', submenuId: 'barcodeprinting' },

    { key: 'Alt + F', description: 'Financial Management', menuId: 'financials' },
    { key: 'Alt + Shift + 1', description: 'New Transaction', menuId: 'financials', submenuId: 'newtransaction' },
    { key: 'Alt + Shift + 2', description: 'All Transactions', menuId: 'financials', submenuId: 'alltransactions' },
    { key: 'Alt + Shift + 3', description: 'Accounts', menuId: 'financials', submenuId: 'accounts' },
    { key: 'Alt + Shift + 4', description: 'Cash & Bank Ledger', menuId: 'financials', submenuId: 'cashledger' },

    { key: 'Alt + W', description: 'Warranty Management', menuId: 'warranty' },
    { key: 'Alt + Shift + 5', description: 'Add Warranty', menuId: 'warranty', submenuId: 'addwarranty' },
    { key: 'Alt + Shift + 6', description: 'Warranty List', menuId: 'warranty', submenuId: 'warrantylist' },

    { key: 'Alt + L', description: 'Billing & Renewals', menuId: 'billing' },
    { key: 'Alt + Shift + 7', description: 'Generate Bill', menuId: 'billing', submenuId: 'generatebill' },
    { key: 'Alt + Shift + 8', description: 'Billing History', menuId: 'billing', submenuId: 'billinghistory' },
    { key: 'Alt + Shift + 9', description: 'Renewals', menuId: 'billing', submenuId: 'renewals' },

    { key: 'Alt + O', description: 'System Settings', menuId: 'settings' },
    { key: 'Alt + N', description: 'User Management', menuId: 'settings', submenuId: 'users' },
    { key: 'Alt + V', description: 'Notifications Center', menuId: 'settings', submenuId: 'systemupdates' },

    { key: 'Escape', description: 'Hide or show sidebar', action: 'toggleSidebar' },
    { key: 'Alt + J', description: 'Open or close shop switcher', action: 'toggleShopSwitcher' },
    { key: 'Alt + M', description: 'Change to next theme color', action: 'cycleTheme' },
    { key: 'Alt + X', description: 'Switch dark or light mode', action: 'toggleDarkMode' },
    { key: 'Alt + Q', description: 'Focus menu search', action: 'focusSearch' },
    { key: 'Alt + Y', description: 'Change to next language', action: 'cycleLanguage' },
    { key: 'Alt + H', description: 'Show or hide keyboard shortcuts', action: 'toggleShortcuts' }
  ]
};
